import {observable, action, computed} from "mobx";
import Config from "../config";

class AuthStore {
	
	@observable token = '';
	@observable isLoggedIn = false;

	constructor() {
		this.token = Config.TOKEN || localStorage.getItem(Config.wx_token_key) || '';
		this.isLoggedIn = !!this.token;
	}

	@action
	setToken(token) {
		this.token = token;
		this.isLoggedIn = !!token;
		Config.TOKEN = token;
		localStorage.setItem(Config.wx_token_key, token);
	}

	@action
	clearToken() {
		this.token = '';
		this.isLoggedIn = false;
		Config.TOKEN = '';
		localStorage.removeItem(Config.wx_token_key);
	}

	@action
	reloadPage() {
		window.location.reload();
	}
}

const authStore = new AuthStore();

export {authStore};
